<dx-popup
    #workflowPaymentHistoryPopup
    minWidth="150px"
    minHeight="150px"
    width="50%"
    height="40%"
    title="Payment History For AAP Workflow Job # {{ workflowId }}"
    [showTitle]="true"
    [showCloseButton]="true"
    [shading]="false"
    [dragEnabled]="!loadingVisible"
    [resizeEnabled]="true"
    [closeOnOutsideClick]="false"
    [visible]="visible"
    (onShown)="onPaymentHistoryShown()"
    (onHidden)="onPaymentHistoryClose()"
>
    <div id="paymentHistory" *dxTemplate="let data of 'content'">
        <dx-box width="100%" height="100%" direction="col">
            <dxi-item [ratio]="1" [visible]="!hasSourceData">
                <div *dxTemplate>
                    <div class="no-data-container">There are no payment history data.</div>
                </div>
            </dxi-item>

            <dxi-item [ratio]="1" [visible]="hasSourceData">
                <div *dxTemplate>
                    <dx-data-grid
                        height="100%"
                        allowColumnResizing="true"
                        [dataSource]="paymentHistorySource"
                        [showColumnLines]="true"
                        [showRowLines]="true"
                        [hoverStateEnabled]="true"
                        [columnAutoWidth]="true"
                        [showBorders]="true"
                    >
                        <dxo-selection mode="single"></dxo-selection>

                        <dxi-column dataField="id" dataType="number" caption="Line #"></dxi-column>
                        <dxi-column
                            dataField="lineAmount"
                            dataType="number"
                            caption="Line Amount"
                            [format]="currencyFormat"
                        ></dxi-column>
                        <dxi-column
                            dataField="paymentNumber"
                            dataType="number"
                            caption="Check #"
                            cellTemplate="paymentNumberCellTemplate"
                        ></dxi-column>
                        <dxi-column
                            dataField="checkDate"
                            dataType="date"
                            caption="Payment Date"
                            [format]="dateFormat"
                        ></dxi-column>
                        <dxi-column
                            dataField="paymentAmount"
                            dataType="number"
                            caption="Payment Amount"
                            [format]="currencyFormat"
                        ></dxi-column>
                        <dxi-column dataField="paymentMethod" dataType="string" caption="Payment Method"></dxi-column>
                        <dxi-column dataField="cleared" caption="Cleared"></dxi-column>

                        <div *dxTemplate="let d of 'paymentNumberCellTemplate'">
                            <app-hyperlink-creator
                                [displayText]="d.value"
                                (onLinkClick)="onPaymentNumberClick(d.data)"
                            ></app-hyperlink-creator>
                        </div>
                    </dx-data-grid>
                </div>
            </dxi-item>
            <dxi-item baseSize="auto">
                <div *dxTemplate class="button-container">
                    <dx-toolbar>
                        <dxi-item location="before">
                            <div *dxTemplate>
                                <dx-button
                                    type="default"
                                    text="Close"
                                    [icon]="iconClose"
                                    (onClick)="onPaymentHistoryClose()"
                                ></dx-button>
                            </div>
                        </dxi-item>
                    </dx-toolbar>
                </div>
            </dxi-item>
        </dx-box>
    </div>
</dx-popup>

<dx-load-panel
    [position]="{ of: '#paymentHistory' }"
    *ngIf="loadingVisible"
    [visible]="loadingVisible"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [closeOnOutsideClick]="false"
></dx-load-panel>
